import ContactComponent from "../components/contactcomponents/contactcomponent"

const ContactPage = ()=>{
    return(<ContactComponent/>)
}
export default ContactPage